import React from 'react'
import OrderNavBar from './Customers/OrderNavBar'

export default function AdminCustomersLeft() {
  return (
    <OrderNavBar />
  )
}

